import routerOptions0 from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}